// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1nm1d","col":"styles_col__19UkU","fulfillmentStatus":"styles_fulfillmentStatus__qCJAp","emailCol":"styles_emailCol__yEyq5"};